import React, { useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import "../assets/css/styles.table.css"
import Sidebar from './Sidebar';
import Header from './Header';
import Layout from './Layout';
import Box from '@mui/material/Box';
import { DataGrid, gridColumnGroupsLookupSelector, GridToolbar } from '@mui/x-data-grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {apiUrl} from './UrlParam'; 
import AxiosFetchData from './AxiosFetchData';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import poHeader from '../assets/img/po/header.gif';
import poSign from '../assets/img/po/apv-sign.gif';
import poFooter from '../assets/img/po/footer.gif';
import {Modal, Typography} from '@mui/material';
import angkaTerbilang from '@develoka/angka-terbilang-js';
import   {FetchData}    from './FetchData.js';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import Helper from './Helper';
import BackButton from '../components/BackButton';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ConfirmationButton from '../components/ConfirmationButton.js';
import MainPrint from './MainPrint.js';
import RetentionPrint from './RetentionPrint.js';
import UploadFile from '../components/Upload.js';
import VirtualizedSelect from 'react-virtualized-select';

const InvoiceListV2 = () => {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [token, setToken] = useState('');
  const [expire, setExpire] = useState('');
  const Navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [rowNumber, setRowNumber] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [print, setPrint] = useState(false);
  const [productList, setProductList] = useState([]);
  const [note, setNote] = useState('');
  const [content, setContent] = useState('');
  const [dataInvoice, setDataInvoice] = useState({});
  const [html, setHtml] = useState('');
  const [total, setTotal] = useState(0);
  const [customer, setCustomer] = useState([]);
  const [tipe, setTipe] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState({});
  const open = Boolean(anchorEl);
  const [message, setmessage] = useState('');
  const [openRetention, setOpenRetention] = React.useState(false);
  const [selectedOptionPeriod, setSelectedOptionPeriod] = useState({});
  const [period, setPeriod] = useState('');
  const [retensi, setRetensi] = useState(0);
  const [ret, setRet] = useState(0);
  const [periodNumber, setPeriodNumber] = useState(0);
  const [isNullRetention, setIsNullRetention] = useState(false);
  const [roleAccess, setRoleAccess] = useState('');
  const [productopen, setproductopen] = useState(false);
  const [invoiceId, setInvoiceId] = useState(null);
  const [projectList, setProjectList] = useState([]);
  const [selectedOptionProject,setSelectedOptionProject] = useState('');
  const [projectId, setProjectId] = useState(null);

  const handleClick = (event,data) => {
    //alert(id)
    setSelectedData(data)
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  var result = "";
  var nbsp = "&nbsp;"
  var totalInvoice = 0;
  
  var mainPrint = new MainPrint(id);

  useEffect(() => {
    async function fetchRetention() {
      let response = await GetRetention();
      if(response){
        if(response.data == null){
          if(id!="00000000000000"){
            setIsNullRetention(true)
            setOpenRetention(true);
          }
        
        }
      }
    }
    GetProjectList();
    fetchRetention();
    GetStatus();
    fetchData();
    
  //    return new Promise(async(resolve, reject)=> {
  //     const resp = await GetRetention();
  //     if(resp.data == null){
  //       setOpenRetention(true);
  //     }
  //     //resolve();    
  // } );
   
  
    // Call the function to fetch data when the component mounts
  }, [id]); // Add token as a dependency if it's required
  
  function GetProjectList(){
    axios.get(`${apiUrl}/api/GetAllListPO`)
    .then((response) => {
     
      const transformedOptions = response.data.map((item) => ({
        label: `${item.name} --- ${item.subject} (QUOTATION NO :${item.quotation_id} , PO NO: ${item.po_no})`,
        value: item.id,
      }));

      transformedOptions.unshift({label :'ALL INVOICES', value :"00000000000000"})
      setProjectList(transformedOptions);
      setSelectedOptionProject(id)
    
    })
    .catch((error) => {
      console.error('Error fetching category data:', error);
    });
 
  }

  function handleSelectedProject(option){
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('ReturnUrl');
        if(myParam){
          Navigate(`/InvoiceListV2/${option.value}?ReturnUrl=${myParam}`)
        }else{
          Navigate(`/InvoiceListV2/${option.value}`)
        }
  }

  const GetRetention = async function (projectId=null) {
    try {
       
      const response = await AxiosFetchData.get(`GetRetention/${projectId == null ? id : projectId}`).refreshToken(Navigate);
     
      return response;
   
   } catch (error) {
     setmessage(error.message);
     
   }

  }

  const fetchData =  async () => {
    try {
       
       const response = await AxiosFetchData.get(`GetAllInvoice/${id}`).refreshToken(Navigate,"invoice");
       
       if(response){
          setRows(response.data); // Update rows with project data
          setRoleAccess(response.roleaccess); 
          // Add row numbers to the rows
          const rowsWithRowNumbers = response.data.map((row, index) => ({
            ...row,
            rowNumber: index + 1, 
            
          }));
          setRows(rowsWithRowNumbers);

         
       }
    
    } catch (error) {
      setmessage(error.message);
      //console.error('Error fetching project data:', error.message);
    }
  };

  function GetStatus(){
    axios.get(`${apiUrl}/api/GetStatusInvoice`)
    .then((response) => {
      const transformedOptions = response.data.map((item) => ({
        label: `${item}`,
        value: item,
      }));
      setStatusList(transformedOptions);
      //return transformedOptions;
    })
    .catch((error) => {
      console.error('Error fetching category data:', error);
    });
     
}

async function  handlePrintInvoice(id, projectId,duedate){
  try{
    // setProjectId(projectId)
    // var ret = await GetRetention(projectId)
    // if(ret.data == null){
    //         setIsNullRetention(true)
    //         setOpenRetention(true);
    //         return;
    // }
    
    var response = await AxiosFetchData.get(`GetInvoice/${id}`).refreshToken(Navigate);
    setAnchorEl(false)
    if(response){
        setTipe("invoice");
    // console.log(response.data.data)
        GetTreeView(response.data);
        setProductList(response.data);

        response.data.resp.tax =response.data.quotation.tax
        setDataInvoice(response.data.resp);
       // setDataInvoice(response.data.resp);
        var ret = await GetRetention(projectId)
        setRet(ret.data.retensi)
      // console.log(ret.data.retensi)
        setCustomer(response.data.customer);
        setHtml(result);
        setTotal(totalInvoice);

       
        if(response.data.resp.deskripsi == "RETENTION"){
        
          mainPrint = new RetentionPrint(id)
        }

        response.data.customer[0].duedate = duedate;
        // setContent({__html: popupContent(`${result}`, response.data.customer, response.data.resp)});
        setContent({__html: mainPrint.printInvoiceV2(`${result}`, response.data.customer, response.data.resp, ret.data.retensi)});
      
    }
    setPrint(true);
  }catch(error){
    setmessage(error.message);
  }
    
}


  function GetTreeView(data)
{
    // console.log(data)
    var no =1;
    for(let i = 0; i < data.data.length; i++){
           
            result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                        <td>&nbsp;</td>`

                        if(data.data[i].part_no){
                            result +=  `<td>${no++}.</td>`
                        }else{
                            result += `<td>&nbsp;</td>`
                        }
                       
              result += `<td>${data.data[i].part_no ? data.data[i].part_no : ""}</td>
                        <td>${ data.data[i].descriptions ? data.data[i].descriptions.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''}</td>
                        <td>${data.data[i].newqty ? data.data[i].newqty : ""}</td>
                         <td>${data.data[i].unit_name ? data.data[i].unit_name : ""}</td>
                        <td>${data.data[i].price ?  Helper.formatAsCurrency(data.data[i].price) : ""}</td>
                       
                        <td>${(data.data[i].newqty && data.data[i].price) ?  Helper.formatAsCurrency(data.data[i].newqty * data.data[i].price) : ""}</td>
                </tr>`
            if(data.data[i].newqty && data.data[i].price){
                totalInvoice += data.data[i].newqty * data.data[i].price
            }

            recursive(data.data[i].subChild);
         
            nbsp ="";
       
    }
  
}

//var nbsp = "&nbsp;"
function recursive(data)
{
   // console.log(data)
    if( data.length > 0){
        
        nbsp += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
        for(let i = 0; i < data.length; i++){
        
                result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>${nbsp}${data[i].part_no ? data[i].part_no : ""}</td>
                            <td>${nbsp}- ${data[i].descriptions.replace(/(?:\r\n|\r|\n)/g, '<br>')}</td>
                            <td>${data[i].newqty ? data[i].newqty : ""}</td>
                              <td>${data[i].unit_name ?  data[i].unit_name : ""}</td>
                            <td>${data[i].price ? Helper.formatAsCurrency(data[i].price) : "-"}</td>
                          
                            <td>${(data[i].newqty && data[i].price) ? Helper.formatAsCurrency((data[i].newqty * data[i].price)) : ""}</td>
                        </tr>`

                        if(data[i].newqty && data[i].price){
                            totalInvoice += data[i].newqty * data[i].price
                        }
                   // if(data[i].subChild.length > 0) {
                        recursive(data[i].subChild);
                  //  }
                  
        //nbsp = ""

        }
        //nbsp = ""
    }
   
}
 

async function  handlePrintKwitansi(id,projectId){
  try{
    // setProjectId(projectId)
    // var ret = await GetRetention(projectId)
    // if(ret.data == null){
    //         setIsNullRetention(true)
    //         setOpenRetention(true);
    //         setAnchorEl(false);
    //         return;
    // }

    const response = await AxiosFetchData.get(`GetInvoice/${id}`).refreshToken(Navigate);
    setAnchorEl(false)
    if(response){
        setTipe("kwitansi")
    
        GetTreeView(response.data);
        setProductList(response.data);
        response.data.resp.tax =response.data.quotation.tax
        setDataInvoice(response.data.resp);
        var ret = await GetRetention(projectId)
        setRet(ret.data.retensi)
        setCustomer(response.data.customer);
        setHtml(result);
        setTotal(totalInvoice);
        if(response.data.resp.deskripsi == "RETENTION"){
          mainPrint = new RetentionPrint(id)
        }
        setContent({__html: mainPrint.printKwitansiV2(`${result}`, response.data.customer, response.data.resp, ret.data.retensi)});
       
    }
    setPrint(true);
  }catch(e){
    setmessage(e.message)
  }
    
}

const columns = [
  { field: 'rowNumber', headerName: 'No.', width: 80 },
  { field: 'subject', headerName: 'Project Name', width: 250 },
  { field: 'kode', headerName: 'Code', width: 280 },
  { field: 'tanggal', headerName: 'Date', width: 100 },
  { field: 'persentase', headerName: 'inv(%)', width: 100 },
  
  // { field: 'total_all', headerName: 'Grand Total', width: 120, valueGetter:({ value }) => value && Helper.formatAsCurrency(value)  },
   
  { field: 'total', headerName: 'Total', width: 100, valueGetter:({ value }) => value && Helper.formatAsCurrency(value)  },
  // { field: 'deskripsi', headerName: 'Description', width: 150 },
//   { field: 'status', headerName: 'Status', width: 150 },
  {
    field: 'actions2',
    headerName: 'Status',
    width: 150,
    renderCell: (params) => <StatusList data={params.row}/>,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 180,
    renderCell: (params) => (
      <>
      <Button
        id={"basic-button" + params.row.rowNumber}
        aria-controls={open ? 'basic-menu' + params.row.rowNumber : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
       
        onClick={(evt) => handleClick(evt, params.row)}
      >
        <MoreVertIcon sx={{ fontSize: 30 }}/>
      </Button>
 
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem  disabled = {selectedData.deskripsi == "RETENTION" ? true : false}   onClick={() => handleEdit(selectedData.id)} >{selectedData.lastId=='last' ? "EDIT" : "DETAIL"}</MenuItem>
        <MenuItem    onClick={() => handlePrintInvoice(selectedData.id, selectedData.project_id, selectedData.deskripsi)} >PRINT INVOICE</MenuItem>
        <MenuItem   onClick={() => handlePrintKwitansi(selectedData.id, selectedData.project_id)} >PRINT KWINTASI</MenuItem>
        <MenuItem   disabled={selectedData.status  === "Unpaid" ? true :false}  onClick={() => {
          setproductopen(true);
          setInvoiceId(selectedData.id)
          handleClose();
        }} >UPLOAD DOCUMENT/IMAGE </MenuItem>
      </Menu>
     

         {/* <button
          onClick={() => handleEdit(params.row.id)} // Pass the project ID to the edit function
          className="btn btn-primary mr-2"
        >
          Edit
        </button> */}
      {/* <Button
        onClick={() => handleDelete(params.row.id)} // this delete button
        disabled={params.row.lastId=='last' ? false : true}
      >
      <DeleteIcon sx={{ fontSize: 30 }}/>
      </Button> */}
      <ConfirmationButton classname='btn btn-danger' text="Do you want delete this data?" type="button"  title="Delete"    disabled={roleAccess.DELETE == true ? (params.row.lastId =='last' ? false : true) : !roleAccess.DELETE}  onClick={() => handleDelete(params.row.id, params.row.rev)} >
        <DeleteIcon sx={{ fontSize: 15 }}/> Delete   
           </ConfirmationButton>
      </>
      
    ),

  },
];
 

const [filterModel, setFilterModel] = React.useState({
  items: [],
  quickFilterExcludeHiddenColumns: true,
  quickFilterValues: [''],
});

const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
// end table

function AddProjectData() {

  Navigate(`/AddInvoiceV2/${id}${Helper.SetReturnUrl()}`);

}

const handleDelete = async (projectId,rev) => {

 // const confirmed = window.confirm('Are you sure you want to delete this project?');

 // if (confirmed) {
  try {
    var data ={
        id:projectId,
        rev : rev
    }
    const response = await AxiosFetchData.post(`DeleteInvoice`, data).refreshToken(Navigate);
   
    if(response){
      await fetchData();
      setmessage(response.data)
    }
    
  } catch (error) {
    setmessage(error.message)
    //console.error('Error deleting project:', error);
  }
//}
};


const handleEdit = (projectId) => {

  //Navigate(`/EditInvoice/${projectId}?ReturnUrl=InvoiceList/${id}?ReturnUrl=ListPOEng`);
  Navigate(`/EditInvoiceV2/${projectId}${Helper.SetReturnUrl()}`);
};

const StatusList = ({data}) => {
    
    return (
        <FormControl fullWidth>
        <Select
            value={data.status}
            id="demo-multiple-name"
            labelId="demo-simple-select-label"
        //value={personName}
            label="Status"
            disabled={!roleAccess.UPDATE}
            onChange={(evt) => handleSelectedStatus(evt, data)}
       // input={<OutlinedInput label="Name" />}
       // MenuProps={MenuProps}
      >
        {statusList.map((name) => (
          <MenuItem
            key={name.value}
            value={name.value}
            
          >
            {name.label}
          </MenuItem>
        ))}
      </Select>
  </FormControl>
    );
  };
  
  const openPopupAndPrintPo = (data) => {
    //alert(tipe)
    let element = document.getElementById('modalcontent');
    if(dataInvoice.deskripsi == "RETENTION"){
      mainPrint = new RetentionPrint('')
    }
    
    var popup = window.open('', 'PRINT', 'height=400,width=400');
    if(tipe=="invoice"){
        popup.document.write(mainPrint.printInvoice(html, customer, dataInvoice,ret).replace('position: relative','position: fixed').replace('</header><br><br>','</header><br><br><br><br><br><br>'));
        element.innerHTML =  mainPrint.printInvoice(html, customer, dataInvoice,ret);
      }else{
        mainPrint = new MainPrint()
        popup.document.write(mainPrint.printKwitansi(html, customer, dataInvoice,ret).replace('position: relative','position: fixed').replace('</header><br><br>','</header><br><br><br><br><br><br>'));
        element.innerHTML =  mainPrint.printKwitansi(html, customer, dataInvoice,ret);
    }
   
    popup.print(); 
     popup.close();
   
   
   // setContent({__html: popupContent(data)});
     
  }

   
//   const formatKwitansi = (data, cust, invoice) =>{
//     var query = `<style>
//         @page {
//           /* Add your custom page styles here */
//           size: A4; /* or your preferred paper size */
//           margin: 50px; /* Adjust margins as needed */
//         }
  
//         .print-header,
//         .print-footer {
//           position: relative;
//           width: 100%;
//           text-align: center;
//           repeat:repeat-x;
          
       
//         }
  
//         .print-header {
//           top: 0;
//         }
  
//         .print-footer {
//           bottom: 0;
//         }
//         .content {
//         top:370px;
  
//         }
  
//         /* Add more styles as needed */
//       </style>`
//       query += `  <header class="print-header">
//         <img src=${poHeader}  width='100%' alt=''>
//           </header><br><br> `
    
    
//     query += `<table width='100%' border=0 style="font-family:arial;font-size:10">`;
//     query +=`<tr><td colspan='3'>
//                 <table width="100%" border=0>
//                      <tr><td colspan='4' align='left'><h3>${invoice.kode.split('/')[0]}</td></tr> 
//      <tr><td colspan='4' align='center'><h3>KWITANSI</h3></td></tr> 
//      <tr><td style='height:10px'></td><td><td></td></td><td></td></tr> 
//      <tr><td  style='width:150px'>Sudah diterima dari</td><td>:</td><td style='width:'100%'' colspan=2> ` + cust[0].customername.toUpperCase() + `</td> </tr> 
//     <tr><td>Untuk Pembayaran</td><td>:</td><td colspan=2> PELUNASAN PAYMENT-` + invoice.kode.split('-')[1].substring(0,1) + `  ` +  invoice.persentase +  `% INVOICE : <b>` + invoice.kode  + `</b></td></tr> 
//      <tr><td>Uang Sebesar</td><td>:</td><td colspan=2> ` + angkaTerbilang(invoice.total).toUpperCase() + ` RUPIAH</td></tr> 
//                 </table>
    
//     </td></tr>`
//     // query += `<tr><td colspan='3' align='left'><h3>${invoice.kode.split('/')[0]}</td></tr>`;
//     // query += `<tr><td colspan='3' align='center'><h3>KWITANSI</h3></td></tr>`;
//     // query += `<tr><td style='height:10px'></td><td></td><td></td></tr>`;
//     // query += `<tr><td  style='width:200px'>Sudah diterima dari</td><td style='width:'100%'' colspan=2>: ` + cust[0].customername.toUpperCase() + `</td> </tr>`;
//     // query += `<tr><td>Untuk Pembayaran</td><td colspan=2>: PELUNASAN PAYMENT-` + invoice.kode.split('-')[1].substring(0,1) + `  ` +  invoice.persentase +  `% INVOICE : <b>` + invoice.kode  + `</b></td></tr>`;
//     // query += `<tr><td>Uang Sebesar</td><td colspan=2>: ` + angkaTerbilang(invoice.total).toUpperCase() + ` RUPIAH</td></tr>`;
//     query += `<tr><td colspan='3'><hr></td> </tr>`;

//     query += `<tr><td colspan='3'><h4>Rp.` + Helper.formatAsCurrency(invoice.total) +  `,-</h4></td> </tr>`;
//     query += `<tr><td colspan='3' style='height:70px'></td> </tr>`;
//     //var query += "<tr><td colspan='3'><table><tr><td>&nbsp;</td><td>Tanggal:03/14/2024,</br>Tertanda,</td></tr><</table></td> </tr>";
//     query += `<tr><td colspan='2' width="80%">&nbsp;</td><td align='center'>Denpasar : ` + formatDate(new Date()) + `<br><b>CV. Magnum Solusion</b>,</td> </tr>`;
//     query += `<tr><td colspan='3' style='height:70px'></td> </tr>`;
//     query += `<tr><td colspan='2'>&nbsp;</td><td align='center'>(...............................................................)</td> </tr>`;
//     query += `<tr><td colspan='3'><hr></td> </tr>`;
//     //query += `<tr><td style='width:250px'>` + new Date().toLocaleString('en-US', { timeZone: 'SINGAPORE', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) + `</td><td  colspan='2'>Printed by : ${name}</td> </tr>`;
//     query += `</table>`;
//     query += ` <footer class="print-footer">
//           <img src=${poFooter} width='100%' alt=''>
//           </footer>`
//     return query;
// }

function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString('default', { day: '2-digit' });
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.toLocaleString('default', { year: 'numeric' });
    return day + ' ' + month + ' ' + year;
}
 

  // const popupContent = (data, cust, invoice) => {  
   
  //   var query =`
  //   <html>
  //   <head>
  //     <title>${id}</title>
  //     <style>
  //       @page {
  //         /* Add your custom page styles here */
  //         size: A4; /* or your preferred paper size */
  //         margin: 50px; /* Adjust margins as needed */
  //       }
  
  //       .print-header,
  //       .print-footer {
  //         position: relative;
  //         width: 100%;
  //         text-align: center;
  //         repeat:repeat-x;
          
       
  //       }
  
  //       .print-header {
  //         top: 0;
  //       }
  
  //       .print-footer {
  //         bottom: 0;
  //       }
  //       .content {
  //       top:370px;
  
  //       }
  
  //       /* Add more styles as needed */
  //     </style>
  //   </head>
  //   <body>
  
  //     <header class="print-header">
  //       <img src=${poHeader}  width='100%' alt=''>
  //         </header><br><br> 
  //       <table  class="content" width="100%"   border="0" cellpadding="0" cellspacing="0">
  //       <tr>
  //         <td bgcolor="#CCCCCC">
  //         <table width="100%" border="0" align="center" cellpadding="3" cellspacing="0" style="background-color: #ccc; font-family:arial; font-size:11px;">
  //           <tr>
  //             <td width="60%">
  //               <table width="100%" style="font-size:10">
  //                   <tr>
  //                       <td width="100px"><b>BILL TO</b></td>
  //                       <td><b>${cust[0].customername}</b></td>
  //                   </tr>
  //                   <tr>
  //                       <td>&nbsp;</td>
  //                       <td><b>${cust[0].contactname}</b></td>
  //                   </tr>
  //                   <tr>
  //                       <td>&nbsp;</td>
  //                       <td>${cust[0].address}</td>
  //                   </tr>
  //                   <tr>
  //                       <td>&nbsp;</td>
  //                       <td>${cust[0].customertlp}</td>
  //                   </tr>
  //               </table>
  //             </td>
  //             <td valign="top"> 
  //                    <table width="100%" style="font-size:10">
  //                       <tr>
  //                           <td><b>INVOICE NO </b></td>
  //                           <td>: <b>${invoice.kode}</b></td>
  //                       </tr>
  //                        <tr>
  //                           <td>Date</td>
  //                           <td>: ${cust[0].quotationdate}</td>
  //                       </tr>
  //                        <tr>
  //                           <td>Terms</td>
  //                           <td>: ${cust[0].paymenttermname}</td>
  //                       </tr>
  //                       <tr style="background-color:black;color:white">
  //                           <td>DUE DATE</td>
  //                           <td>: ${cust[0].duedate}</td>
  //                       </tr>
  //                    </table>
  //             </td>
               
              
  //           </tr>
             
  //         </table>
  //         </td>
  //       </tr>
  //     </table><br>
     
  
  //       <table width="100%" align="center" border="0" cellpadding="4" cellspacing="0">
  //         <tr style="background-color: #0d47a1; color: #ffffff; font-family:arial; font-size:11px;">
  //           <td width="5%">&nbsp;</td>
  //           <td width="8%">No</td>
  //           <td width="15%">Part No</td>
  //           <td width="32%">Description</td>
  //           <td width="10%">Qty</td>
  //           <td width="6%">Price.</td>
  //           <td width="7%">Unit</td>
  //           <td width="7%">Total</td>
  //         </tr> `
  //         query += data 
  //       //   for(var i =0; i < data.data.length; i++) {
  //       //     if(data.data[i].newqty && data.data[i].price){
  //       //         total +=  data.data[i].newqty * data.data[i].price
  //       //     }
  //       //   }
         
  //       query += `</table> 
  
  //       <table  style="font-family:arial; font-size:11px;"  width="100%"  border="0" align="center" cellPadding="0" cellSpacing="0">
  //           <tr>
  //               <td colspan="2" style="height:40px">&nbsp;</td>
  //           </tr>
  //           <tr>
  //           <td width="60%">
  //               <table width="100%" style="font-size:10">
  //               <tr>
  //                   <td><b>Note:</b></td>
  //                </tr>
  //                <tr>
  //                   <td><b>-NPWP Register No. 02.788.174.7-907.000 CV. MAGNUM SOLUSION</b></td>
  //                </tr>
  //                <tr>
  //                   <td>&nbsp;</td>
  //                </tr>
  //                <tr>
  //                   <td><b>Bank Account :</b></td>
  //                </tr>
  //                <tr>
  //                   <td>- BRI : 024801002892302 A/N CV. Magnum Solusion</td>
  //                </tr>
  //                <tr>
  //                   <td>&nbsp;</td>
  //                </tr>
  //                <tr>
  //                   <td>if there is a late payment will be subject to a 5% fina;ty per month </td>
  //                </tr>
  //                <tr>
  //                   <td>Let's maintain commitment in doing buiness</td>
  //               </tr>
  //                </table>
  //           </td>
  //           <td>
  //               <table width="100%" style="font-size:10">
  //                   <tr>
  //                       <td width="290px"  style='text-align:left;padding-right:10px'>SUB TOTAL</td>
  //                       <td>${Helper.formatAsCurrency(invoice.total)}</td>
  //                   </tr>
  //                   <tr>
  //                       <td  style='text-align:left;padding-right:10px'>RETENSI 5%</td>
  //                       <td>&nbsp;</td>
  //                   </tr>
  //                   <tr>
  //                       <td  style='text-align:left;padding-right:10px'>TOTAL</td>
  //                       <td>${Helper.formatAsCurrency(invoice.total)}</td>
  //                   </tr>
  //                   <tr style="background-color:black">
  //                       <td  style='text-align:left;padding-right:10px;color:white'>BALANCE DUE</td>
  //                       <td style='color:white'>${Helper.formatAsCurrency(invoice.total)}</td>
  //                   </tr>
  //               </table>
  //           </td>
             
  //         </tr>
  //       </table>
       
  //       <img src=${poSign} width='100%' alt=''>
  
  //       <footer class="print-footer">
  //         <img src=${poFooter} width='100%' alt=''>
  //         </footer>
  
  
  //       </body></html>
  //   `;
  //   return query;
  //   }
  
  async function  handleSelectedStatus(event, data){
   try{
    var data = {
      status : event.target.value,
      id : data.id
 }
     const response = await AxiosFetchData.post(`UpdateStatusInvoice`, data).refreshToken(Navigate)
     if(response){
         await fetchData();
         setmessage(response.data)
     }
   }catch(e){
      setmessage(e.message)
   }
   
  }

  async function handleRetentionClose(event, reason){
    if(rows.length == 0){
      if(reason !== "backdropClick"){
        setOpenRetention(false);
      }
    }else{
      setOpenRetention(false);
    }
  }

  async function handleSaveRetention(event){
    event.preventDefault();
    //setOpenRetention(false);
    setIsNullRetention(false)
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    
    var data = {
              project_id : id,
              retensi : formJson.txtRtn,
              period_number :  formJson.txtPeriod,
              period : formJson.optPeriod,
              isDelete : 0
            }
            //alert(email);
    try{
          var response = await AxiosFetchData.post(`UpdateRetention`, data).refreshToken(Navigate)
          setmessage(response.data);
          await fetchData();
        }catch(e){
          setmessage(e.message);
        }
           
        handleRetentionClose();
}

function handleUploadDialogClose(){

  setproductopen(false)
  //handleClose();
}

  return (
    <>
       
    <Layout message={message} setmessage={setmessage}>
  <div className='pd'><b>INVOICE LIST</b> 
  
  </div>
 
  <div className="pd">
 
  <div style={{backgroundColor:"gray", padding:10, marginBottom:20}}>
   
        <VirtualizedSelect
                                        options={projectList}
                                        onChange={(option) =>  handleSelectedProject(option)}
                                        value={selectedOptionProject}
                                        clearable={false}
                                        searchable={true}
                                        required
                                       
                                    /><br></br>
        
    </div>
  <Box sx={{ p: 2,m:0, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3,fontSize:12}}>
      Note : Invoice use the latest data from the PO, changes to PO data after the invoice is issued do not change the invoice, except for the addition of PO. So make sure the data is fixed before filling in the invoice
    </Box>
    <div style={{position:'relative'}}>
    {id !=="00000000000000" && (
       <div style={{marginBottom:15}}><button className='btn btn-success' onClick={AddProjectData} disabled={!roleAccess.CREATE}>Add Invoice</button></div>
    )}
       <div style={{position:'absolute', right:0,top:0}}>
        {id !=="00000000000000" && (
       <button className='btn btn-primary hide' disabled={!roleAccess.CREATE} onClick={async () => {
           // const response = await AxiosFetchData.get(`GetRetention/${id}`).refreshToken(Navigate);
            const response = await GetRetention();
           // console.log(response)
            if(response.data){
              setRetensi(response.data.retensi)
              setPeriodNumber(response.data.period_number)
              setPeriod(response.data.period)
            }
            setOpenRetention(true)
        }}>Retention</button>
      )}
       <Dialog
        open={openRetention}
        onClose={handleRetentionClose}
        height={450}
        // PaperProps={{
        //   component: 'form',
        //   onSubmit: async (event) => {
        //     event.preventDefault();
        //     const formData = new FormData(event.currentTarget);
        //     const formJson = Object.fromEntries(formData.entries());
        //     alert(formJson.txtRtn)
        //     var data = {
        //       project_id : id,
        //       retensi : formJson.txtRtn,
        //       period_number :  formJson.txtPeriod,
        //       period : formJson.optPeriod,
        //       isDelete : 0
        //     }
        //     //alert(email);
        //     try{
        //         var response = await AxiosFetchData.post(`UpdateRetention`, data).refreshToken(Navigate)
        //         setmessage(response.data);
        //     }catch(e){
        //       setmessage(e.message);
        //     }
           
        //     handleRetentionClose();
        //   },
        // }}
      >
        
        <form id="formRetention" onSubmit={handleSaveRetention} >
        <DialogContent>
          <DialogContentText>
          <h4>RETENTION</h4><br></br>
          {isNullRetention && (
             <span style={{fontSize:12}}>You must fill in the retention before continue</span>
          )}
         
            <hr></hr>
          </DialogContentText>
         
           <FormControl sx={{ m: 1}} size="small" > 
          
              <div className='form-group row'>
                <label class="col-sm-4">Retention</label>
                <div class="col-sm-4">
                  <input
                              type="number"
                              className="form-control"
                              placeholder="Retention"
                              value={retensi}
                              onChange={(e) => setRetensi(e.target.value) }
                              name="txtRtn"
                              min={0}
                              required
                             
                             // onChange={(e) => handleText(e.target.value, index)}
                            />
              </div>
              <label >%</label>
            </div>
            <div className='form-group row'>
              <label  class="col-sm-4">Time Period</label>
              <div class="col-sm-4">
<               input
                              type="number"
                              className="form-control"
                              placeholder="Retention"
                              value={periodNumber}
                              onChange={(e) => setPeriodNumber(e.target.value) }
                              name="txtPeriod"
                              min={0}
                              required
                             
                         
                            />
              </div>
              <div class="col-sm-4">
           
              <Select
                value={period}
                onChange={(event)=> setPeriod(event.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                required
                name="optPeriod"
              >
                 <MenuItem value="">
            <em>None</em>
              </MenuItem>
                <MenuItem value={"YEAR"}>Year</MenuItem>
                <MenuItem value={"MONTH"}>Month</MenuItem>
                <MenuItem value={"WEEK"}>Week</MenuItem>
                <MenuItem value={"DAY"}>Day</MenuItem>
              </Select>
            
          </div>  
          </div>    
          
           </FormControl>       
           <hr></hr>
        </DialogContent>
        <DialogActions>
          <button className='btn btn-danger' onClick={() => handleRetentionClose()} type="button"   >CANCEL</button>
          {/* <button className='btn btn-primary' type="submit">SAVE1</button>   */}
          <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit"  title="Save" disabled={!roleAccess.CREATE} formid="formRetention" id="btnSubmit" >
               SAVE    
           </ConfirmationButton>
        </DialogActions>
        </form>    
      </Dialog>
       </div>
    </div>
   
  <Box sx={{ width: 1 }} >
      
      <Box sx={{ height: 550 }} >
        <DataGrid className='fonty'
          columns={columns}
          rows={rows}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
        />
      </Box>
    </Box>
    </div>
 
  <Modal
        open={print}
        onClose={() => setPrint(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="satu"
      >
        <Box className='modals' >
        <div id="testId" className="test"> 
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div id="modalcontent" dangerouslySetInnerHTML={content}>
              
            </div>
           
          </Typography>
          <Typography id="modal-modal-description">
          <button
              onClick={() => openPopupAndPrintPo(result)}
              className='close-button'
            >
              Print
            </button>
            &nbsp;
            <button
              onClick={() => setPrint(false)}
              className='close-button'
            >
              Close
            </button>
          </Typography>
          </div>
        </Box>
        </Modal>
 
        <UploadFile productopen={productopen} handleClose={handleUploadDialogClose}  id={invoiceId} navigate={Navigate} table="invoice" type="invoice"></UploadFile>
        </Layout>

    </>
  );
};

export default InvoiceListV2;